// Header Navigation - Dropdown Hover & Keyboard Behavior

class HeaderNavigation {
  constructor() {
    this.activeDropdown = null;
    this.openTimeout = null;
    this.closeTimeout = null;
    this.OPEN_DELAY = 0;
    this.CLOSE_DELAY = 500;

    this.init();
  }

  init() {
    const navItems = document.querySelectorAll('.nav-item.has-dropdown');

    navItems.forEach((item) => {
      const link = item.querySelector('.header-menu__item--parent');
      const dropdown = item.querySelector('.nav-dropdown');

      if (!link || !dropdown) return;

      // Mouse events
      link.addEventListener('mouseenter', () => {
        this.handleMouseEnter(item, dropdown);
      });

      link.addEventListener('mouseleave', () => {
        this.handleMouseLeave(item, dropdown);
      });

      dropdown.addEventListener('mouseenter', () => {
        this.handleDropdownEnter(item, dropdown);
      });

      dropdown.addEventListener('mouseleave', () => {
        this.handleMouseLeave(item, dropdown);
      });

      // Keyboard events
      link.addEventListener('keydown', (e) => {
        this.handleKeydown(e, item, dropdown);
      });
    });

    // Close dropdown on Escape
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.activeDropdown) {
        this.closeDropdown(this.activeDropdown);
        this.activeDropdown = null;

        // Return focus to parent link
        const parentLink = document.querySelector(
          '.nav-item.is-open .header-menu__item--parent'
        );
        if (parentLink) parentLink.focus();
      }
    });
  }

  handleKeydown(e, item, dropdown) {
    const isOpen = dropdown.classList.contains('is-open');

    switch (e.key) {
      case 'Enter':
        // Enter on parent link - just navigate (default behavior)
        // Don't preventDefault, let the link work
        break;

      case ' ': // Space
        e.preventDefault();

        if (isOpen) {
          // Close dropdown
          this.closeDropdown(dropdown);
          this.activeDropdown = null;
        } else {
          // Close any other open dropdown first
          if (this.activeDropdown) {
            this.closeDropdown(this.activeDropdown);
          }
          // Open this dropdown
          this.openDropdown(dropdown);
          this.activeDropdown = dropdown;

          // Focus first link in dropdown after short delay
          setTimeout(() => {
            const firstLink = dropdown.querySelector('a');
            if (firstLink) firstLink.focus();
          }, 100);
        }
        break;

      case 'ArrowDown':
        e.preventDefault();

        if (!isOpen) {
          // Open dropdown
          if (this.activeDropdown) {
            this.closeDropdown(this.activeDropdown);
          }
          this.openDropdown(dropdown);
          this.activeDropdown = dropdown;
        }

        // Focus first link in dropdown
        const firstLink = dropdown.querySelector('a');
        if (firstLink) firstLink.focus();
        break;

      case 'ArrowUp':
        if (isOpen) {
          e.preventDefault();
          // Focus last link in dropdown
          const links = dropdown.querySelectorAll('a');
          const lastLink = links[links.length - 1];
          if (lastLink) lastLink.focus();
        }
        break;
    }
  }

  handleMouseEnter(item, dropdown) {
    clearTimeout(this.closeTimeout);

    const isSwitching = this.activeDropdown && this.activeDropdown !== dropdown;

    if (isSwitching) {
      const oldDropdown = this.activeDropdown;

      oldDropdown.classList.add('no-transition');
      dropdown.classList.add('no-transition');

      oldDropdown.offsetHeight;
      dropdown.offsetHeight;

      this.closeDropdown(oldDropdown);
      this.openDropdown(dropdown);
      this.activeDropdown = dropdown;

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          oldDropdown.classList.remove('no-transition');
          dropdown.classList.remove('no-transition');
        });
      });

      return;
    }

    clearTimeout(this.openTimeout);

    this.openTimeout = setTimeout(() => {
      this.openDropdown(dropdown);
      this.activeDropdown = dropdown;
    }, this.OPEN_DELAY);
  }

  handleDropdownEnter(item, dropdown) {
    clearTimeout(this.closeTimeout);
  }

  handleMouseLeave(item, dropdown) {
    clearTimeout(this.openTimeout);

    this.closeTimeout = setTimeout(() => {
      this.closeDropdown(dropdown);
      if (this.activeDropdown === dropdown) {
        this.activeDropdown = null;
      }
    }, this.CLOSE_DELAY);
  }

  openDropdown(dropdown) {
    dropdown.classList.add('is-open');
    dropdown.setAttribute('aria-hidden', 'false');

    const parent = dropdown.closest('.nav-item');
    if (parent) {
      parent.classList.add('is-open');

      // Update aria-expanded on parent link
      const parentLink = parent.querySelector('.header-menu__item--parent');
      if (parentLink) {
        parentLink.setAttribute('aria-expanded', 'true');
      }
    }
  }

  closeDropdown(dropdown) {
    dropdown.classList.remove('is-open');
    dropdown.setAttribute('aria-hidden', 'true');

    const parent = dropdown.closest('.nav-item');
    if (parent) {
      parent.classList.remove('is-open');

      // Update aria-expanded on parent link
      const parentLink = parent.querySelector('.header-menu__item--parent');
      if (parentLink) {
        parentLink.setAttribute('aria-expanded', 'false');
      }
    }
  }
}

// Initialize
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new HeaderNavigation();
  });
} else {
  new HeaderNavigation();
}
